import { render } from "./SubChannelManagement.vue?vue&type=template&id=43bbcfd2&scoped=true"
import script from "./SubChannelManagement.vue?vue&type=script&lang=js"
export * from "./SubChannelManagement.vue?vue&type=script&lang=js"

import "./SubChannelManagement.vue?vue&type=style&index=0&id=43bbcfd2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bbcfd2"]])

export default __exports__